import { type ReactNode, useCallback, useMemo, useState } from 'react';

import { DialogOpenedContext } from '.';

type Props = {
  children: ReactNode;
};
export const DialogOpenedProvider = ({ children }: Props) => {
  const [currentlyOpenedDialogs, setCurrentlyOpenedDialogs] = useState<
    Map<string, boolean>
  >(new Map());

  const dispatchOpenEvent = useCallback((dialogId: string) => {
    setCurrentlyOpenedDialogs(prev => {
      if (!prev.has(dialogId)) {
        return new Map(prev).set(dialogId, true);
      }
      return prev;
    });
  }, []);

  const dispatchCloseEvent = useCallback((dialogId: string) => {
    setCurrentlyOpenedDialogs(prev => {
      if (prev.has(dialogId)) {
        return new Map(prev).set(dialogId, false);
      }
      return prev;
    });
  }, []);

  const numberOfOpenedDialogs = useMemo(() => {
    return Array.from(currentlyOpenedDialogs.values()).filter(Boolean).length;
  }, [currentlyOpenedDialogs]);

  return (
    <DialogOpenedContext.Provider
      value={{
        numberOfOpenedDialogs,
        isDialogOpen: numberOfOpenedDialogs > 0,
        dispatchOpenEvent,
        dispatchCloseEvent,
      }}
    >
      {children}
    </DialogOpenedContext.Provider>
  );
};
